import * as React from 'react';

import ClearIcon from '@mui/icons-material/Clear';
import CopyIcon from '@mui/icons-material/CopyAll';

import SpeedDial from '@mui/material/SpeedDial';
import SpeedDialIcon from '@mui/material/SpeedDialIcon';
import SpeedDialAction from '@mui/material/SpeedDialAction';

export default function Actions({ onClear, onCopy }) {
  return <SpeedDial
    ariaLabel="Actions"
    sx={{ position: 'absolute', bottom: 16, right: 16 }}
    icon={<SpeedDialIcon />}
  >
    <SpeedDialAction
      icon={<CopyIcon />}
      tooltipTitle="Kapijavać"
      onClick={onCopy}
    />
    <SpeedDialAction
      icon={<ClearIcon />}
      tooltipTitle="Ačyscić"
      onClick={onClear}
    />
  </SpeedDial>;
}